import { render } from "./ApartmentsFilter.vue?vue&type=template&id=162c3ab4&scoped=true"
import script from "./ApartmentsFilter.vue?vue&type=script&lang=js"
export * from "./ApartmentsFilter.vue?vue&type=script&lang=js"

import "./ApartmentsFilter.vue?vue&type=style&index=0&id=162c3ab4&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-162c3ab4"]])

export default __exports__